import { createMutation } from "react-query-kit";
import type { MutationFunction } from "@tanstack/react-query";

import type { IPickMutation } from "../types";
import { getApi } from "../apiPath";
import { axiosClient, queryClient } from "../clients";

import type { IAcademicGroups } from "./routeType";
import { useGetAllAcademicGroup } from "./getAll";

const { getPath } = getApi("academicGroups.post");

type IExtractedRouteType = IAcademicGroups["academicGroupSingleCreate"];

export type IPostAcademicGroup = IPickMutation<IExtractedRouteType>;

const postAcademicGroup: MutationFunction<
  IPostAcademicGroup["response"],
  IPostAcademicGroup["variables"]
> = (data) => {
  return axiosClient.post(getPath(), data);
};

export const usePostAcademicGroup = createMutation({
  mutationFn: postAcademicGroup,
  onSuccess: (_) => {
    queryClient.invalidateQueries({
      queryKey: useGetAllAcademicGroup.getKey(),
    });
  },
});
